import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import config from '@/config';
import UserModule from '@/stores/UserStore';
import PlatformModule from '@/stores/PlatformStore';
import AppModule from '@/stores/AppStore';
import NotificationModule from '@/stores/NotificationStore';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: `${config.nameApp}-${config.platformUuid}`,
  modules: ['user', 'platform', 'app'],
});

const store = new Vuex.Store({
  modules: {
    user: UserModule,
    platform: PlatformModule,
    app: AppModule,
    notifications: NotificationModule,
  },
  plugins: [vuexLocal.plugin],
});
export default store;

export function flashDanger(...args) {
  return store.dispatch('notifications/flashDanger', ...args);
}
